import type { MouseEvent } from 'react';

type EditableSectionHeadingProps = {
  label: string;
  /** Underlying content field selected when the heading is clicked in studio preview. */
  fieldKey: string;
  editable?: boolean;
  className?: string;
};

/** Static section label that selects an underlying content field in studio preview. */
export function EditableSectionHeading({
  label,
  fieldKey,
  editable,
  className,
}: EditableSectionHeadingProps) {
  const editAttrs = editable
    ? ({
        'data-edit-child': 'content-field',
        'data-field-key': fieldKey,
      } as const)
    : {};

  const handleClick = (event: MouseEvent<HTMLParagraphElement>) => {
    if (editable) {
      event.preventDefault();
    }
  };

  return (
    <p
      className={className || undefined}
      {...editAttrs}
      {...(editable ? { onClick: handleClick } : {})}
    >
      {label}
    </p>
  );
}
